<script lang="ts">
    import QrScanner from "qr-scanner";
    import {onDestroy, onMount} from "svelte";
    import variables from "$lib/variables.js";
    import {page} from "$app/stores";
    import {getProjectAssignees, getProject, checkIn} from "$lib/calls/project";
    import Card from "$lib/components/ui/Card.svelte";
    import Avatar from "$lib/components/Avatar.svelte";
    import dayjs from "dayjs";
    import { fade } from 'svelte/transition';
    import CustomerAvatar from "$lib/components/CustomerAvatar.svelte";
    import {Button, Modal} from "flowbite-svelte";
    import CheckInModal from "$lib/partials/checkInCheckout/CheckInModal.svelte";
    import {roundToNearest15} from "$lib/utils/roundTime";
    import CheckOutModal from "$lib/partials/checkInCheckout/CheckOutModal.svelte";

    let videoElement = null;
    let qrScanner = null;

    let project = null;
    let assignees = [];
    let showCards = [];
    let showCheckInModal = false;
    let showCheckOutModal = false;

    let currentAssignee = null;


    const onScan = res => {
        // modals open?
        if(showCheckInModal || showCheckOutModal){
            return;
        }

        for(let i = 0; i < assignees.length; i++) {
            if(res.data.includes(assignees[i].employee.identityCode) ){
                currentAssignee = assignees[i];
                console.log({currentAssignee})

                // checkin or checkout?
                const signedIn = assignees.find(x => !!x.actualStart.value && x.id === currentAssignee.id)
                if(signedIn){
                    showCheckOutModal = true;
                } else {
                    showCheckInModal = true;
                    // onScanCheckin()
                }

                // checkIn(project.uuid, assignees[i].id)
            }
        }
        showCards = showCards.sort((a,b) => b.actualStart.stamp - a.actualStart.stamp);
    }


    const updateAssignees = () => {
        assignees = [...assignees.filter(x => x.id !== currentAssignee.id), currentAssignee]
        showCards = [...showCards.filter(x => x.id !== currentAssignee.id), currentAssignee]
        console.log({assignees})
    }





    onMount(() => {
        getProject($page.params.uuid).then(res => {
            project = res;
            console.log({project})
        })
        getProjectAssignees($page.params.uuid).then(res => {

            assignees = res;
            console.log({assignees})
        })
        qrScanner = new QrScanner(
            videoElement,
            onScan,
            {
                maxScansPerSecond: 10,
                highlightScanRegion: true,
                highlightCodeOutline: true
            },
        );

        qrScanner.$overlay.firstChild.style.stroke = variables.primary;
        qrScanner.setCamera('user')
        qrScanner.start()
    })
    onDestroy(()=>{
        if(qrScanner){
            qrScanner.destroy()
        }

    })

    $: expected = assignees.filter(x => !x.actualStart.value).sort((a,b) => a.plannedStart.stamp - b.plannedStart.stamp)

</script>
<CheckInModal realTime={project?.customer?.realTimeCheckin} bind:assignee={currentAssignee} bind:showCheckInModal on:selected={updateAssignees} />
<CheckOutModal realTime={project?.customer?.realTimeCheckin} bind:assignee={currentAssignee} bind:showCheckOutModal on:selected={updateAssignees} />
<div>
    {#if project}
        <div class="flex gap-5 px-5 py-2 justify-between items-center bg-gray-50 border-b border-gray-200">
            <CustomerAvatar size="2xl" customer={project.customer}/>
            <p class="text-2xl text-neutral-600 hidden md:block">{project.customer.name}</p>
            <div>
                <a href="/project/{$page.params.uuid}" class="mb-3 text-2xl text-neutral-600">{project?.name}</a>
                <p>{dayjs(project.startsAt.value).format('DD.MM.YYYY')} - {dayjs(project.endsAt.value).format('DD.MM.YYYY')}</p>
            </div>
        </div>


    {:else }
        <div class="h-[56px]"></div>
    {/if}
    <div class="my-5">
        <Card>
            <div class="grid grid-cols-3 gap-3 py-3">
                <video class="col-span-3 lg:col-span-2" bind:this={videoElement}></video>
                <div>
                    <ul class="px-3 h-96 overflow-y-auto">
                        {#each showCards as assignee}
                            <li class="mb-3" transition:fade|global>
                                <Card>
                                    <div class="flex gap-3 align-content-center py-3">
                                        <Avatar associate={assignee.employee} />
                                        <div class="text-coolGray-600 self-center">
                                            {assignee.employee.firstName} {assignee.employee.lastName}
                                        </div>
                                    </div>
                                    <div class="flex gap-3 py-3 text-coolGray-600">
                                        <span>{dayjs(assignee.plannedStart.value).format('HH:mm [Uhr]')}</span>
                                        <span>-</span>
                                        <span>{dayjs(assignee.plannedEnd.value).format('HH:mm [Uhr]')}</span>

                                    </div>
                                    <div class="flex gap-3 py-3">
                                        <i class="las la-check-circle mt-1"></i>
                                        <div class="text-coolGray-600 ">
                                            {dayjs(assignee.actualStart.value).format('HH:mm [Uhr]')}
                                        </div>
                                    </div>


                                </Card>
                            </li>
                        {/each}
                    </ul>
                </div>

            </div>
        </Card>
    </div>


    <Card >
        <div class="grid grid-cols-2 gap-3 py-3">
            <div>
                <h2 class="text-xl text-center text-neutral-600">Checked in</h2>
                <ul class="divide-y divide-gray-100 rounded-md border border-gray-200">
                    {#each assignees.filter(x => !!x.actualStart.value) as checkedIn}
                        <li class="flex items-center justify-between py-4 pl-4 pr-5 text-sm leading-6">
                            <Avatar associate={checkedIn.employee} />
                            <span>{checkedIn.employee.firstName} {checkedIn.employee.lastName}</span>
                            <span>{dayjs(checkedIn.plannedStart.value).format('HH:mm [Uhr]')} - {dayjs(checkedIn.plannedEnd.value).format('HH:mm [Uhr]')}</span>
                        </li>
                    {/each}
                </ul>
            </div>
            <div>
                <h2 class="text-xl text-center text-neutral-600">Expected</h2>
                <ul class="divide-y divide-gray-100 rounded-md border border-gray-200">
                    {#each expected as checkedIn}
                        <li class="flex items-center justify-between py-4 pl-4 pr-5 text-sm leading-6">
                            <Avatar associate={checkedIn.employee} />
                            <span>{checkedIn.employee.firstName} {checkedIn.employee.lastName}</span>
                            <span>{dayjs(checkedIn.plannedStart.value).format('HH:mm [Uhr]')} - {dayjs(checkedIn.plannedEnd.value).format('HH:mm [Uhr]')}</span>
                        </li>
                    {/each}
                </ul>
            </div>
        </div>
    </Card>

</div>
